export var FactorRequestResponseInclude = {
    factorRequest: true,
    files: true,
};
//# sourceMappingURL=FactorRequestResponse.js.map